window.dataLayer = window.dataLayer || [];
import { pushToDataLayer } from '@/js/analytics/analytics.methods';

const cardBrowserControls = [...document.querySelectorAll('.js-card-browser-controls-ga')];

function bindEventListener(el) {
  const actions = [...el.querySelectorAll('button')];  

  actions.forEach(action => {
    action.addEventListener('click', () => {
      pushToDataLayer({                
        "event": "card_browser_control_click",
        "link_text": action.dataset.gaLabel
      });
    });
  })
}

function init() {
  if (!cardBrowserControls.length) {
    return;
  }

  cardBrowserControls.forEach(bindEventListener);
}

export default init;
